import React from 'react';

import Separator from '../components/Separator';

import moduleCorrelations from './moduleCorrelations';
import moduleParsers from './moduleParsers';

function identity(config) {
  return config;
}

async function parseConfiguration(
  { type, config },
  locale,
  domain,
  graphqlClient
) {
  const newConfig = await (moduleParsers[type]
    ? moduleParsers[type](config, locale, domain, graphqlClient)
    : config);

  return { type, config: newConfig };
}

function mustAddSeparator(i, nModules) {
  return i !== 0 && i !== nModules - 1;
}

function loadModule({ type, config }, i, moduleList) {
  const ModuleToLoad = moduleCorrelations[type];
  return ModuleToLoad && config ? (
    <React.Fragment key={`${type}_${i}`}>
      <ModuleToLoad {...config} />
      {mustAddSeparator(i, moduleList.length) ? (
        <Separator key={`separator_${i}`} />
      ) : null}
    </React.Fragment>
  ) : null;
}

export function parseConfigurations(config, locale, domain, graphqlClient) {
  return config
    .map(configToParse =>
      parseConfiguration(configToParse, locale, domain, graphqlClient)
    )
    .filter(identity);
}

export function loadModules(config) {
  return config.map(loadModule).filter(identity);
}

export default {
  loadModules,
  parseConfigurations
};
